import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import IkeaLogo from '../assets/ikea-logo.svg';
import { useKompis } from '../contexts';
import { useIsKiosk } from '../contexts/environment';
const Container = styled.div `
  display: flex;
  width: 90px;
  height: 36px;

  a {
    width: 90px;
    height: 36px;
  }
`;
const Image = styled.img `
  height: 100%;
  cursor: pointer;
`;
const Logo = () => {
    //TODO destruct links when state is initialized before loading app
    //TODO proper aria-label
    const isKiosk = useIsKiosk();
    const { dexfAppSettings } = useKompis();
    const link = getLogoLink(dexfAppSettings.kompis.urls);
    const handleClick = () => {
        if (!isKiosk) {
            window.open(link, '_self');
        }
    };
    return (_jsx(Container, { children: _jsx("a", { onClick: () => handleClick(), "aria-label": 'Navigate to ikea.com', children: _jsx(Image, { src: IkeaLogo, alt: 'IKEA logo' }) }) }));
};
const getLogoLink = (urls) => {
    if (!urls) {
        return '';
    }
    const { platformDomainOverride, homePageLink } = urls;
    return platformDomainOverride || homePageLink;
};
export default Logo;
//# sourceMappingURL=Logo.js.map